import qs from 'query-string';
import instance from 'api/instance';
import { ICreateVisitLog, IGetVisitLogs } from './types';

export const getVisigLogs: IGetVisitLogs = (params) => instance.get(`/visit-logs?${qs.stringify(params, { skipEmptyString: true })}`);

export const createVisitLog: ICreateVisitLog = (data) =>
	instance.post('/visit-logs', data);